import { render, staticRenderFns } from "./VideoUploadView.vue?vue&type=template&id=57d2e254&scoped=true&"
import script from "./VideoUploadView.vue?vue&type=script&lang=js&"
export * from "./VideoUploadView.vue?vue&type=script&lang=js&"
import style0 from "./VideoUploadView.vue?vue&type=style&index=0&id=57d2e254&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d2e254",
  null
  
)

export default component.exports